import { Box, Tooltip, Typography } from '@mui/material';
import { getInitials } from '../../../components/exo/ExoAvatar';

export const TableCategories = ({ categories }) => {
  const catCount = categories?.length || 0;

  const onlyIcons = catCount > 1;

  return (
    <Box className="flex gap-1 w-[100px] lg:w-[200px] xl:w-[250px] 2xl:w-[300px] max-w-full justify-start flex-wrap">
      {categories?.map((cat) => (
        <SmallCategory key={cat.id} category={cat} onlyIcons={onlyIcons} />
      ))}
    </Box>
  );
};
const SmallCategory = ({ category, onlyIcons }) => {
  const { label, color, icon } = category;

  const initials = getInitials(label);

  return (
    <Tooltip title={label}>
      <Box
        sx={{
          bgcolor: color + '30',
          border: `1px solid ${color}80`,
          width: onlyIcons ? '29px' : '100%',
        }}
        className="min-w-[29px] h-[29px] rounded-md flex items-center justify-start gap-1 px-1"
      >
        {icon && <img className="w-[25px]" src={icon.temporaryUrl} />}
        {!onlyIcons && (
          <Typography
            sx={{ color }}
            className=" whitespace-nowrap text-ellipsis max-w-[150px] overflow-hidden"
          >
            {label}
          </Typography>
        )}
      </Box>
    </Tooltip>
  );
};
